import { Stage } from '@eventbrite/webapp-constants';

export const CORE_HOSTS: Record<string, string> = {
    [Stage.LOCAL]: 'localhost',
    [Stage.TEST]: 'evbqa.com',
    [Stage.PROD]: 'eventbrite.com',
};

export const APPLICATION_BASE_PATH = '/home';
